var map = {
	"./views/app-calendar/app-calendar.module": [
		"./src/app/views/app-calendar/app-calendar.module.ts",
		"common",
		"views-app-calendar-app-calendar-module"
	],
	"./views/app-chats/app-chats.module": [
		"./src/app/views/app-chats/app-chats.module.ts",
		"views-app-chats-app-chats-module"
	],
	"./views/app-dialogs/app-dialogs.module": [
		"./src/app/views/app-dialogs/app-dialogs.module.ts",
		"views-app-dialogs-app-dialogs-module"
	],
	"./views/app-inbox/app-inbox.module": [
		"./src/app/views/app-inbox/app-inbox.module.ts",
		"views-app-inbox-app-inbox-module~views-forms-forms-module",
		"common",
		"views-app-inbox-app-inbox-module"
	],
	"./views/app-tour/app-tour.module": [
		"./src/app/views/app-tour/app-tour.module.ts",
		"views-app-tour-app-tour-module"
	],
	"./views/charts/charts.module": [
		"./src/app/views/charts/charts.module.ts",
		"views-charts-charts-module~views-dashboard-dashboard-module~views-others-others-module~views-profile~2658a0a7",
		"common",
		"views-charts-charts-module"
	],
	"./views/cruds/cruds.module": [
		"./src/app/views/cruds/cruds.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"common",
		"views-cruds-cruds-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-charts-charts-module~views-dashboard-dashboard-module~views-others-others-module~views-profile~2658a0a7",
		"views-dashboard-dashboard-module~views-dres-dres-module~views-profile-profile-module~views-sessions-~a3dbf94a",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/dragndrop/dragndrop.module": [
		"./src/app/views/dragndrop/dragndrop.module.ts",
		"views-dragndrop-dragndrop-module"
	],
	"./views/dres/dres.module": [
		"./src/app/views/dres/dres.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-dashboard-dashboard-module~views-dres-dres-module~views-profile-profile-module~views-sessions-~a3dbf94a",
		"common",
		"views-dres-dres-module"
	],
	"./views/forms/forms.module": [
		"./src/app/views/forms/forms.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-forms-forms-module~views-others-others-module~views-profile-profile-module~views-shop_service-~5cbc636c",
		"views-forms-forms-module~views-profile-profile-module~views-sessions-sessions-module",
		"views-app-inbox-app-inbox-module~views-forms-forms-module",
		"common",
		"views-forms-forms-module"
	],
	"./views/home/home.module": [
		"./src/app/views/home/home.module.ts",
		"views-home-home-module"
	],
	"./views/map/map.module": [
		"./src/app/views/map/map.module.ts",
		"common",
		"views-map-map-module"
	],
	"./views/mat-icons/mat-icons.module": [
		"./src/app/views/mat-icons/mat-icons.module.ts",
		"views-mat-icons-mat-icons-module"
	],
	"./views/material/app-material.module": [
		"./src/app/views/material/app-material.module.ts",
		"views-material-app-material-module"
	],
	"./views/others/others.module": [
		"./src/app/views/others/others.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-charts-charts-module~views-dashboard-dashboard-module~views-others-others-module~views-profile~2658a0a7",
		"views-forms-forms-module~views-others-others-module~views-profile-profile-module~views-shop_service-~5cbc636c",
		"common",
		"views-others-others-module"
	],
	"./views/profile/profile.module": [
		"./src/app/views/profile/profile.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-charts-charts-module~views-dashboard-dashboard-module~views-others-others-module~views-profile~2658a0a7",
		"views-dashboard-dashboard-module~views-dres-dres-module~views-profile-profile-module~views-sessions-~a3dbf94a",
		"views-forms-forms-module~views-others-others-module~views-profile-profile-module~views-shop_service-~5cbc636c",
		"views-forms-forms-module~views-profile-profile-module~views-sessions-sessions-module",
		"views-profile-profile-module~views-sessions-sessions-module",
		"common",
		"views-profile-profile-module"
	],
	"./views/sessions/sessions.module": [
		"./src/app/views/sessions/sessions.module.ts",
		"views-dashboard-dashboard-module~views-dres-dres-module~views-profile-profile-module~views-sessions-~a3dbf94a",
		"views-forms-forms-module~views-profile-profile-module~views-sessions-sessions-module",
		"views-profile-profile-module~views-sessions-sessions-module",
		"common",
		"views-sessions-sessions-module"
	],
	"./views/shop/shop.module": [
		"./src/app/views/shop/shop.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-shop-shop-module~views-shop_service-shopstetic-module",
		"common",
		"views-shop-shop-module"
	],
	"./views/shop_service/shopstetic.module": [
		"./src/app/views/shop_service/shopstetic.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"views-forms-forms-module~views-others-others-module~views-profile-profile-module~views-shop_service-~5cbc636c",
		"views-shop-shop-module~views-shop_service-shopstetic-module",
		"common",
		"views-shop_service-shopstetic-module"
	],
	"./views/tables/tables.module": [
		"./src/app/views/tables/tables.module.ts",
		"views-cruds-cruds-module~views-dashboard-dashboard-module~views-dres-dres-module~views-forms-forms-m~78b98f57",
		"common",
		"views-tables-tables-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;